module.exports = __webpack_public_path__ + "static/media/map.52eeced1.svg";